const fontFamily = {
  name: "font-family",
  path: "/font-family",
  title: "font-family",
  description: "Utilities for controlling the font family of an element.",
  value: {
    "font-family": {
      "font-family-sans": 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
      "font-family-serif": 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
      "font-family-mono": 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
      "font-family-[<value>]": "<value>",
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="font-sans text-lg">The quick brown fox jumps over the lazy dog. (font-sans)</p>
<p class="font-serif text-lg">The quick brown fox jumps over the lazy dog. (font-serif)</p>
<p class="font-mono text-lg">The quick brown fox jumps over the lazy dog. (font-mono)</p>
        `
      }
    },
        {
      example: {
        code: `
<p class="font-family-[Open_Sans] ...">
  Lorem ipsum dolor sit amet...
</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">font-sans</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">font-serif</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">font-mono</code> to change the font family:
      </p>
      <div class="space-y-2">
        <p class="font-sans text-lg  p-2 rounded">The quick brown fox jumps over the lazy dog. (font-sans)</p>
        <p class="font-serif text-lg  p-2 rounded">The quick brown fox jumps over the lazy dog. (font-serif)</p>
        <p class="font-mono text-lg  p-2 rounded">The quick brown fox jumps over the lazy dog. (font-mono)</p>
      </div>
      `
    },
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">font-[<value>]</code> syntax to set the font family based on a completely custom value:
      </p>
      <div class="space-y-2">
        <p class="font-family-[Open_Sans] text-lg  p-2 rounded">The quick brown fox jumps over the lazy dog.</p>      </div>
      `
    }
]
}
export default fontFamily;
<div className="font-family-[Open_Sans] sr-only"></div>